
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.076 10.37L5.78 12.666c-.95.95-2.494.95-3.443 0a2.419 2.419 0 01-.714-1.722c0-.65.254-1.262.713-1.722l2.296-2.295a.812.812 0 00-1.148-1.148L1.19 8.074v.001A4.032 4.032 0 000 10.945c0 1.083.422 2.102 1.189 2.869A4.046 4.046 0 004.059 15c1.039 0 2.078-.396 2.869-1.187l2.296-2.296a.812.812 0 00-1.148-1.148zM15 4.056a4.032 4.032 0 00-1.188-2.87 4.063 4.063 0 00-5.74 0v.001L5.777 3.483A.812.812 0 106.925 4.63L9.22 2.335c.95-.95 2.495-.95 3.444 0 .46.46.713 1.071.713 1.721a2.42 2.42 0 01-.713 1.722l-2.296 2.296a.812.812 0 001.148 1.148l2.296-2.296a4.032 4.032 0 001.189-2.87z"}}),_c('path',{attrs:{"d":"M4.628 10.37a.81.81 0 001.148 0l4.592-4.592A.812.812 0 109.22 4.63L4.628 9.222a.812.812 0 000 1.148z"}})])
          )
        }
      }
    